var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-alerts"},_vm._l((_vm.messages),function(message){return _c('div',{key:message,staticClass:"alert alert-success"},[_vm._v(_vm._s(message))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }